/* Jahresbox: Kaufoption Einmalkauf / Sparabo
   Gehoert zu snippets/jahresbox-native-buybox.liquid.

   Das Abo gewaehrt KEINEN Rabatt. Der einzige Unterschied zum Einmalkauf ist
   der Gratis-Unkrautvernichter, der nach dem Add-to-Cart dazugelegt wird.
   Das Skript setzt daher nur zwei Dinge:
     1. ein verstecktes selling_plan-Feld im nativen Kaufformular
     2. das Gratis-Produkt nach erfolgreichem Add-to-Cart
   Die Preisanzeige des Themes bleibt unangetastet. */
(function () {
  function init() {
    var root = document.getElementById('jhbBuy');
    if (!root || root.dataset.jhbInit === '1') return;
    root.dataset.jhbInit = '1';

    var SELLING_PLAN = root.dataset.sellingPlan;
    var GIFT_VARIANT = parseInt(root.dataset.giftVariant, 10);

    var cards = root.querySelectorAll('.jhb-card');
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var mode = 'one';

    /* selling_plan im nativen Formular setzen bzw. entfernen */
    function syncSellingPlan() {
      if (!form) return;
      var input = form.querySelector('input[name="selling_plan"]');
      if (mode === 'sub') {
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          form.appendChild(input);
        }
        input.value = SELLING_PLAN;
      } else if (input) {
        input.parentNode.removeChild(input);
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        mode = card.dataset.mode;
        cards.forEach(function (c) {
          c.classList.toggle('is-active', c === card);
          c.setAttribute('aria-checked', c === card ? 'true' : 'false');
        });
        syncSellingPlan();
      });
    });

    /* Gratis-Geschenk: nach erfolgreichem nativen Add-to-Cart im Abo-Modus nachlegen.
       Das native Formular kann nur eine Position senden - das Geschenk kommt daher
       als zweiter Aufruf hinterher. Doppelte Zugabe wird ueber /cart.js verhindert. */
    var productForm = document.querySelector('[data-js-product-form]');

    if (GIFT_VARIANT && productForm) {
      productForm.addEventListener('add-to-cart', function () {
        if (mode !== 'sub') return;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var already = (cart.items || []).some(function (item) {
              return item.variant_id === GIFT_VARIANT;
            });
            if (already) return null;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1 }] })
            });
          })
          .then(function (res) {
            if (res && typeof window.refreshCart === 'function') window.refreshCart();
          })
          .catch(function (err) {
            console.error('[jahresbox] Geschenk konnte nicht hinzugefuegt werden', err);
          });
      });
    }

    syncSellingPlan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();